// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'grad-solid';

export const Component = () => (
  <>
    <path d='m13.363 10.173 6.753 1.484-7.855 3.161L0 9.885 12.26 5l12.261 4.885-3.017 1.245a1.802 1.802 0 0 0-.288-.239L14.368 9.36c-.288-.288-.91-.432-1.868-.432h-.335c-1.102.048-1.628.288-1.628.623 0 .431.67.67 1.963.67.431 0 .719 0 .862-.047Zm-1.101 5.651 6.37-2.538v2.97H5.891v-2.97l6.37 2.538Zm-6.37.43H18.63c0 .72-.622 1.294-1.82 1.773-1.244.478-2.777.718-4.55.718-1.77 0-3.304-.239-4.5-.718-1.246-.48-1.869-1.054-1.869-1.772Zm15.709-.478h-1.006v.479h1.006v-.48Z' />
    <path d='m21.074 11.85.107.006c.269.038.42.222.42.52v2.441l.118.009a.96.96 0 0 1 .551.28.96.96 0 0 1 .28.55l.008.12v1.484c0 .298-.114.445-.374.474l-.105.005h-1.963c-.298 0-.445-.114-.474-.374l-.005-.105v-1.484c0-.24.096-.48.287-.67a.96.96 0 0 1 .551-.28l.12-.008v-2.442l.006-.107c.029-.269.175-.42.473-.42Z' />
  </>
);

export const viewBox = '0 0 25 25';
